import { Pipe, PipeTransform } from '@angular/core';
import { OrderDirection } from '@zero/shared/util-models';
import { MultiOrderInstrument } from '@zero/trade/domain';

@Pipe({
  name: 'hasMultiOrderInstrument',
  standalone: true,
})
export class HasMultiOrderInstrumentPipe implements PipeTransform {
  public transform(isin: string, assets: MultiOrderInstrument[], direction: OrderDirection): boolean {
    return !!assets?.filter((instrument) => instrument.direction === direction)?.some((i) => i.isin === isin);
  }
}
